import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import { DropDownFilter, TextInput } from 'components/InputsMex/inputs';
import { emailRegex } from 'components/InputsMex/validaciones';
import { usePantallaPago } from 'contexts/FormPagoContext';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { preventDefault } from 'utils/funciones';
import { MEDIOS_PAGO, SUB_MEDIOS_PAGO } from '../constants';
import CancelarTokenCorreo from './CancelarTokenCorreo';
import DetalleValores from './DetalleValores';
import FormTarjeta from './FormTarjeta';

const FormPago = ({ codProducto }) => {
  const statePantalla = usePantallaPago();

  const methods = useFormContext();
  const medioPago = methods.watch('medioPago');
  const subMedio = methods.watch('subMedio');

  useEffect(() => {
    methods.setValue('subMedio', null);
  }, [medioPago]);

  return (
    <form className="row justify-content-center justify-content-lg-around" onSubmit={preventDefault}>
      <div className="col-12 col-lg-6 order-1 order-lg-0">
        <div className="row m-0 m-md-4 m-xl-5">
          {statePantalla.showFormPago === true && (
            <React.Fragment>
              <div className="col-12">
                <SimpleContainer name="medioPago" label="Selecciona el medio de pago">
                  <DropDownFilter
                    name="medioPago"
                    options={statePantalla.mediosPago}
                    rules={{ required: 'Este campo es obligatorio' }}
                    disabled={statePantalla.loadingForm}
                  />
                </SimpleContainer>
              </div>

              {[MEDIOS_PAGO.pago, MEDIOS_PAGO.suscripcion].includes(medioPago?.value) && (
                <React.Fragment>
                  <div className="col-12">
                    <SimpleContainer name="subMedio" label="Selecciona como procesar tu pago">
                      <DropDownFilter
                        name="subMedio"
                        rules={{ required: 'Este campo es obligatorio' }}
                        options={statePantalla.subMedios}
                        disabled={statePantalla.loadingForm}
                      />
                    </SimpleContainer>
                  </div>

                  {subMedio?.value === SUB_MEDIOS_PAGO.correo && (
                    <div className="col-12">
                      <SimpleContainer name="correo" label="Enviar enlace de cobro a">
                        <TextInput
                          inputProps={{
                            name: 'correo',
                            disabled: statePantalla.loadingForm,
                          }}
                          defaultValue={statePantalla?.catalogo?.emailContratante}
                          hideArrows
                          rules={{
                            required: 'Este campo es obligatorio',
                            pattern: {
                              value: emailRegex,
                              message: 'Ingrese un correo válido',
                            },
                          }}
                        />
                      </SimpleContainer>
                    </div>
                  )}

                  {subMedio?.value === SUB_MEDIOS_PAGO.tarjeta && (
                    <React.Fragment>
                      <FormTarjeta />
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}

              {medioPago?.value === MEDIOS_PAGO.pagoTradicional && (
                <div className="col-12">
                  <h1 className="font-20px text-justify">
                    Realiza tu pago en los establecimientos autorizados que encontrarás en el recibo de cobro con el
                    número de referencia emitido con tu póliza.
                  </h1>
                </div>
              )}
            </React.Fragment>
          )}
          {statePantalla.showFormCancelarTokens === true && (
            <div className="col-12">
              <CancelarTokenCorreo />
            </div>
          )}
        </div>
      </div>
      <DetalleValores datosTarifacion={statePantalla.datosTarifacion} codProducto={codProducto} />
    </form>
  );
};

export default FormPago;
